var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBottom)?_c('div',[_c('md-bottom-bar',{attrs:{"md-sync-route":""}},_vm._l((_vm.menus),function(menu){return _c('md-bottom-bar-item',{key:menu.name,attrs:{"to":menu.path,"md-label":menu.name,"md-icon":menu.icon}})}))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }